module.exports = __webpack_public_path__ + "static/media/system_flow_bill_credit.45340108.svg";